import React from 'react'
import { useDispatch } from 'react-redux'
import { setPrevCompaignTab } from 'redux/actions/newCompaignActions';

const GoBackBtn = () => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setPrevCompaignTab());
    }

    return (
        <div className='flex items-center gap-1 mb-8 text-primary cursor-pointer w-fit'
        onClick={handleClick}
        >
            <i className="uil uil-arrow-left text-xl "></i>
            <p>Back</p>
        </div>
    )
}

export default GoBackBtn